export const ARCHIVELIST_PAGE = 'ARCHIVELIST_PAGE';
export const ARCHIVELIST_SEARCH = 'ARCHIVELIST_SEARCH';